import React from "react";
import PropTypes from "prop-types";
import createReactClass from "create-react-class";

export default createReactClass({
  displayName: "Root",
  propTypes: {
    circle: PropTypes.object.isRequired,
    isMyCircleUri: PropTypes.bool,
  },
  getInitialState() {
    return {
      circle: this.props.circle,
    };
  },
  onError() {
    var updated = this.state.circle;
    updated.main_image_url = "/images/ja2/img_noimage.gif";
    this.setState({
      circle: updated,
    });
  },
  render() {
    var circle = this.state.circle;
    var uri = this.props.isMyCircleUri ? "/circle/" : "/circle/";
    return (
      <div className="touch-box overflow-hidden mr5" style={{ width: "100px" }}>
        <article className="circle-box" style={{ height: "100%" }}>
          <a className="timeline_circle-link" href={`${uri}${circle.id}`}>
            <div className="timeline_circle-image">
              <img
                src={circle.main_image_url}
                alt={circle.name}
                onError={this.onError}
                style={{ width: "auto", height: "100%" }}
              />
              <div
                className="timeline_circle-description background-gradient"
                style={{ position: "absolute", bottom: "0" }}
              >
                <h3
                  className="line-2 font-size-12 mb0"
                  style={{ color: "#fff", lineHeight: "1.7" }}
                >
                  {circle.name}
                </h3>
              </div>
            </div>
          </a>
        </article>
      </div>
    );
  },
});
